
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'oxd-card-table-container',

  computed: {
    classes(): object {
      return {
        'oxd-table': true,
      };
    },
  },
});
